// removed by extract-text-webpack-plugin
module.exports = {"tooltip":"_21PsZ","tooltip-container":"I-zDe","tooltip-open":"_3FjN1","tooltip-trigger":"_2Xc9E","tooltip-delete":"_1sJw7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemTooltip/RichUpdatesItemTooltip.scss
// module id = ./src/components/RichUpdates/RichUpdatesItem/RichUpdatesItemTooltip/RichUpdatesItemTooltip.scss
// module chunks = 4